import reactComponentLoader from 'scripts/react-component-loader'

import Chat from './Chat'

reactComponentLoader(Chat, '[data-backpack-chat-concierge]')
